import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function KnowledgeSiteFilter({
  sites,
  siteId,
  onChange,
}: {
  sites: readonly { id: string; name: string }[];
  siteId: string;
  onChange: (siteId: string) => void;
}) {
  return (
    <label className="flex min-w-0 flex-col gap-1 text-xs sm:text-sm">
      <span className="text-muted-foreground">Standort</span>
      <Select
        value={siteId || 'none'}
        onValueChange={(value) => onChange(value === 'none' ? '' : value)}
      >
        <SelectTrigger
          id="knowledge-site"
          aria-label="Standort"
          size="sm"
          className="w-full min-w-0 lg:w-36"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Alle Standorte</SelectItem>
          {sites.map((site) => (
            <SelectItem key={site.id} value={site.id}>
              {site.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </label>
  );
}
